import { Cancel } from "@radix-ui/react-alert-dialog";

import React from "react";

type AlertCancelProps = {
  children: React.ReactNode;
  onClick?: () => void;
};

const AlertCancel = React.forwardRef<HTMLButtonElement, AlertCancelProps>(
  (props, forwardedRef) => {
    const { children, onClick, ...rest } = props;
    return (
      <Cancel {...rest} asChild onClick={onClick} ref={forwardedRef}>
        {children}
      </Cancel>
    );
  },
);

AlertCancel.displayName = "AlertCancel";

export { AlertCancel };
